import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators';
import { login, getUserInfo, jAccount } from '@/api/users';
import store from '@/store';
import { getToken, setToken, removeToken } from '@/utils/cookies';
import { Role, IUser } from '@/api/types';

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements IUser {
  public token = getToken() || '';
  public username = '';
  public _id = '';
  public jaccountId = '';
  public jaccountType = '';
  public code = '';
  public role = Role.ADMIN;
  public auths: string[] = [];

  get isSuperadmin() {
    return UserModule.role === Role.SUPERADMIN;
  }

  @Mutation
  SET_TOKEN(token: string) {
    this.token = token;
  }

  @Mutation
  SET_USER(user: IUser) {
    Object.keys(user).forEach((key) => {
      this[key] = user[key];
    });
  }

  @Action({ rawError: true })
  public async Login(userInfo: { username: string; password: string }) {
    let { username } = userInfo;
    const { password } = userInfo;
    username = username.trim();
    const { data } = await login({ username, password });
    if (data && data.token) {
      setToken(data.token);
      this.SET_USER(data);
      this.SET_TOKEN(data.token);
    }
  }

  @Action({ rawError: true })
  public async JAccount({ code, redirectUrl }: { code: string; redirectUrl: string }) {
    const { data } = await jAccount({ code, redirectUrl });
    if (data && data.token) {
      if (['teacher', 'staff'].some((i) => i === data.jaccountType)) {
        setToken(data.token);
        this.SET_USER(data);
        this.SET_TOKEN(data.token);
      }
    } else {
      throw Error('Verification failed, please Login again.');
    }
  }

  @Action({ rawError: true })
  public ResetToken() {
    removeToken();
    this.SET_TOKEN('');
  }

  @Action({ rawError: true })
  public async GetUserInfo() {
    if (this.token === '') {
      throw Error('GetUserInfo: token is undefined!');
    }
    const { data } = await getUserInfo();
    if (!data) {
      throw Error('Verification failed, please Login again.');
    }
    this.SET_USER(data);
  }

  @Action({ rawError: true })
  public async LogOut() {
    if (this.token === '') {
      throw Error('LogOut: token is undefined!');
    }
    removeToken();
    this.SET_TOKEN('');
  }
}

export const UserModule = getModule(User);
